import { formatDistanceToNow, format, parse, parseISO } from 'date-fns';

export const timeFormatMixin = {
  methods: {
    formattedTime: (timeAsString) => {
      if (timeAsString === null) return 'null';
      if (typeof timeAsString === 'string') {
        timeAsString = parseISO(timeAsString);
      }
      return format(timeAsString, 'yyyy-MM-dd HH:mm:ss');
    },
    formattedDate: (timeAsString) => {
      if (typeof timeAsString === 'string') {
        timeAsString = parseISO(timeAsString);
      }
      return format(timeAsString, 'yyyy-MM-dd');
    },
    dateInWords: (timeAsString) => {
      if (typeof timeAsString === 'string') {
        return formatDistanceToNow(parseISO(timeAsString));
      }
      return formatDistanceToNow(parse(timeAsString, 'yyyy-MM-dd HH:mm:ss', new Date()));
    },
    apiFormattedDateTime: (timeAsString) => {
      // purchase-order api expects Y-m-d\TH:i:s\Z
      return format(parse(timeAsString, 'yyyy-MM-dd', new Date()), "yyyy-MM-dd'T'HH:mm:ss'Z'");
    },
    parseDate: (timeAsString) => {
      if (timeAsString !== null && timeAsString.length === 10) {
        return parse(timeAsString, 'yyyy-MM-dd', new Date());
      }
      return parse(timeAsString, 'yyyy-MM-dd HH:mm:ss', new Date());
    },
  },
};
